
import { Component, Vue, Watch } from 'vue-property-decorator';
import TradesSidebarView from '@/app/views/dashboard/trades/TradesSidebarView.vue';

@Component({
  components: {
    TradesSidebarView,
  },
})
export default class SideNavTradeLink extends Vue {
  private dashboardOpen: boolean = false;

  get inDashboard() {
    return this.$route.fullPath.includes('/dashboard/trades');
  }

  @Watch('$route.fullPath', { immediate: true })
  onRouteChange() {
    this.dashboardOpen = this.inDashboard;
  }

  toggleDashboard() {
    this.dashboardOpen = !this.dashboardOpen;
  }
}
